import { Injectable } from '@angular/core';
import { Subject, Observable } from "rxjs";
import { Notification, NotificationType } from '../model/notification';


@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  
  private _subject = new Subject<Notification>();
  private _idx = 0;

  constructor() { }

  getObservable(): Observable<Notification> {
    return this._subject.asObservable();
  }

  info(title: string, message: string, timeout = 30000) {
    this._subject.next(new Notification(this._idx++, NotificationType.info, title, message, timeout,null,null));
  }

  success(title: string, message: string, timeout = 30000) {
    this._subject.next(new Notification(this._idx++, NotificationType.success, title, message, timeout,null,null));
  }

  warning(title: string, message: string, timeout = 30000) {
    this._subject.next(new Notification(this._idx++, NotificationType.warning, title, message, timeout,null,null));
  }

  error(title: string, message: string, timeout = 30000) {
    this._subject.next(new Notification(this._idx++, NotificationType.error, title, message, timeout,null,null));
  }
  infoRedir(title: string, message: string, timeout = 30000, messageUrl: string, url: string) {
    this._subject.next(new Notification(this._idx++, NotificationType.info, title, message, timeout,messageUrl,url));
  }

  successRedir(title: string, message: string, timeout = 30000, messageUrl: string, url: string) {
    this._subject.next(new Notification(this._idx++, NotificationType.success, title, message, timeout,messageUrl,url));
  }

  warningRedir(title: string, message: string, timeout = 30000, messageUrl: string, url: string) {
    this._subject.next(new Notification(this._idx++, NotificationType.warning, title, message, timeout,messageUrl,url));
  }

  errorRedir(title: string, message: string, timeout = 30000, messageUrl: string, url: string) {
    this._subject.next(new Notification(this._idx++, NotificationType.error, title, message, timeout,messageUrl,url));
  }
}
